import { Theme } from '@mui/material';
import { makeStyles } from '@mui/styles';

const options = {
  name: 'news-block',
};

const useStyles = makeStyles(
  (theme: Theme) => ({
    root: {},
    allNewsLink: {
      display: 'inline-flex',
      alignItems: 'center',
      '& svg': {
        transform: 'rotate(180deg)',
        marginLeft: theme.spacing(1),
      },
    },
  }),
  options
);

export default useStyles;
